import { createApi } from '@reduxjs/toolkit/query/react'
import { HYDRATE } from 'next-redux-wrapper'

import { SanityQuery } from '~/redux/utils/sanity-query'
import { studytips } from '~/shared/types/studyTips.types'

export const studytipsApi = createApi({
  reducerPath: 'studytipsApi',
  baseQuery: SanityQuery,
  tagTypes: [],
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({
    getStudyTipCategories: builder.query<studytips[], { language: string }>({
      query: (queryParams) => ({
        queryString: `*[_type == "studytips" && language == $language]|order(order asc){
          "name": coalesce(name,''),
          "icon": coalesce(icon.asset->url,''),
          "key": coalesce(key, '')
        }`,
        queryParams,
      }),
    }),
  }),
})

// Export hooks for usage in functional components
export const {
  useGetStudyTipCategoriesQuery,
  util: { getRunningQueriesThunk },
} = studytipsApi

// export endpoints for use in SSR
export const { getStudyTipCategories } = studytipsApi.endpoints
